module.exports = __webpack_public_path__ + "img/31_fineStaff_xq.38fdb804.png";